import { render, staticRenderFns } from "./IconBill.vue?vue&type=template&id=a5224676&"
import script from "./IconBill.vue?vue&type=script&lang=ts&"
export * from "./IconBill.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports